<template>
  <b-container fluid>
    <b-overlay :show="loading">
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                <b-row>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Organiation" vid="org_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="organiation_id"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="forward.org_id"
                                                :options="orgList"
                                                id="organiation_id"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Designation Id" vid="designation_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="designation_id"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{ $t('user_role.designation')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="forward.designation_id"
                                                :options="designationList"
                                                id="designation_id"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Employee Name" vid='employee_id' rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="employee_id "
                                                >
                                                <template v-slot:label>
                                                {{$t('production_store.employee_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="forward.employee_id"
                                                :options="userList"
                                                id="employee_id"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Forward Date" vid='forward_date' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="forward_date"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('production_store.forward_date')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                placeholder="Select Date"
                                                id="forward_date"
                                                v-model="forward.forward_date"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Note (En)" vid='note'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="note"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('production_store.comment_en')}}
                                                </template>
                                                <b-textarea
                                                id="note"
                                                v-model="forward.note"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Note (Bn)" vid='note_bn'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="note_bn"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('production_store.comment_bn')}}
                                                </template>
                                                <b-textarea
                                                id="note_bn"
                                                v-model="forward.note_bn"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                        <b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
                                        &nbsp;
                                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.cancel') }}</b-button>
                                    </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { authServiceBaseUrl, productionServiceBaseUrl } from '../../../../../config/api_config'
import { quotationForwardToForwardApi, userListByDesignationApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.$t('globalTrans.save'),
            forward: {
                org_id: 0,
                designation_id: 0,
                forward_date: '',
                employee_id: 0,
                note: '',
                note_bn: ''
            },
            loading: false,
            designationList: [],
            userList: [],
            ready: false
        }
    },
    created () {
    },
    watch: {
        'forward.org_id': function (newVal, oldVal) {
            this.designationList = this.getDesignationList(newVal)
        },
        'forward.designation_id': function (newVal, oldVal) {
            this.getUserList(newVal)
        },
        currentLocale: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localizeUserList(newVal)
            }
        }
    },
    mounted () {
        core.index()
        flatpickr('#forward_date', {})
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        currentLocale: function () {
            return this.$i18n.locale
        }
    },
    methods: {
        async register () {
            window.vm.$swal({
                title: window.vm.$t('production_store.forward_msg'),
                showCancelButton: true,
                confirmButtonText: window.vm.$t('globalTrans.yes'),
                cancelButtonText: window.vm.$t('globalTrans.no'),
                focusConfirm: false
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch('mutateCommonProperties', { loading: true })
                    // let result = null
                    const loadingState = { loading: false, listReload: true }
                    this.loading = true
                    if (this.id) {
                        RestApi.putData(productionServiceBaseUrl, `${quotationForwardToForwardApi}/${this.id}`, this.forward).then(response => {
                        this.$store.dispatch('mutateCommonProperties', loadingState)
                        this.loading = false
                            if (response.success) {
                                if (response.notification && this.$store.state.emitNotification) {
                                    const notification = response.notification
                                    this.$socket.emit('send-notification', notification)
                                }
                                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                                this.$toast.success({
                                    title: this.$t('globalTrans.success'),
                                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                                    color: '#D6E09B'
                                })
                                this.$bvModal.hide('modal-2')
                            } else {
                                this.$refs.form.setErrors(response.errors)
                            }
                        })
                    }
                }
            })
        },
        getDesignationList (orgId = null) {
            const designationList = this.$store.state.commonObj.designationList
            let listObject = []
            if (orgId) {
                listObject = designationList.filter(designation => designation.org_id === orgId)
            } else {
                listObject = designationList
            }
            const tmpList = listObject.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
                } else {
                return { value: obj.value, text: obj.text_en }
                }
            })
            return tmpList
        },
        getUserList (designationId = null) {
            RestApi.getData(authServiceBaseUrl, `${userListByDesignationApi}/${designationId}`).then(response => {
                const userList = response.map((obj, index) => {
                  return Object.assign({}, obj, {
                    text: this.currentLocale === 'en' ? obj.text_en : obj.text_bn
                  })
                })
                this.userList = userList
                return userList
            })
        },
        localizeUserList (locale) {
            const tmp = this.userList.map(item => {
                return Object.assign({}, item, {
                    text: locale === 'en' ? item.text_en : item.text_bn
                })
            })
            this.userList = tmp
        }
    }
}
</script>
